module.exports = __webpack_public_path__ + "static/media/e1.6fa260d3.jpg";